import { Button, Divider, Icon, Modal } from "semantic-ui-react";
import { dt } from "src/utils/documentsI18n";
import '../../documentostributarios/modalSettleConflictNomina.scss';
import { useContext, useEffect, useState } from "react";
import moment from "moment";
import { formatMoney, formatMoneyWithCurrency, formatRut } from "src/utils/formatter";
import { BodyDocumentDetail } from "./components/BodyDocumentDetail";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { FindDocumentById, GetCostCentersByDocument } from "src/graphql/documents";
import LoadingSpinner from "src/components/general/js/spinnerLoading";
import { FlowContext } from "src/context";
import FilterTabs from "src/components/FilterTabs";

export const ModalDocumentDetail = ({ isVisible, setIsVisible, data }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { data: result, fetching, reexecuteQuery } = FindDocumentById({ ids: data });
  const { data: costCentersByDocumentData, fetching: fetchinCostCenters, reexecuteQuery: reexecuteCostCentersByDocument } = GetCostCentersByDocument({ documentIds: data });
  const [documentCostCenters, setDocumentCostCenters] = useState([]);
  const [selectedTab, setSelectedTab] = useState("Detalles");
  const tabs = [
    { key: "Detalles", label: dt("detail.tabs.details"), value: "Detalles" },
    { key: "Glosa", label: dt("detail.tabs.glosa"), value: "Glosa" },
    { key: "Matchs", label: dt("detail.tabs.matches"), value: "Matchs" },
    { key: "Nóminas", label: dt("detail.tabs.payrolls"), value: "Nóminas" }
  ];

  useEffect(() => {
    if (!costCentersByDocumentData) return;
    setDocumentCostCenters(costCentersByDocumentData.getCostCentersByDocuments);
  }, [costCentersByDocumentData]);

  useEffect(() => {
    if (isVisible) {
      reexecuteCostCentersByDocument({ requestPolicy: 'network-only' });
    }
  }, [isVisible, reexecuteCostCentersByDocument]);

  useEffect(() => {
    if (result && !fetching) {
      setIsLoading(false);
    }
  }, [result, fetching]);

  const history = useHistory();
  const location = useLocation();

  const closeModal = () => {
    const currentParams = new URLSearchParams(location.search);
    currentParams.delete("id");
    currentParams.delete("isDocumentDetail");
    currentParams.delete("isGlobalSearch");
    history.replace({ search: currentParams.toString() });
    setIsVisible(false);
  };

  const processMatches = (data) => {
    if (!data) return;
    const result = {
      documentInput: [],
      transactionInput: [],
      settlesIds:[],
    };

    data?.meta?.matchs?.inMatch.forEach(match => {
      if (match.type === "TRANSACTION") {
        result.transactionInput.push(match.id);
      } else if (["TAX_DOCUMENT", "OBLIGATION", "CREDIT",].includes(match.type)) {
        result.documentInput.push(match.id);
      } else if (["MANUAL"].includes(match.type)) {
        result.settlesIds.push(match.settleId);
      }
    });

    data?.meta?.matchs?.outMatch.forEach(match => {
      if (match.type === "TRANSACTION") {
        result.transactionInput.push(match.id);
      } else if (["TAX_DOCUMENT", "OBLIGATION", "CREDIT"].includes(match.type)) {
        result.documentInput.push(match.id);
      }
    });

    return result;
  };

  const processedData = processMatches(result?.findDocumentsById[0]);
  const doc = result?.findDocumentsById[0] || [];

  return (
    <>
      <Modal dimmer="blurring" open={isVisible} style={{maxWidth:'80%'}}>
        <Modal.Header className="!tw-text-lg tw-font-semibold tw-text-gray-700 tw-font-sans tw-text-center">
          {dt('detail.modalHeader', {
            summary: doc?.meta?.summary || doc?.meta?.typeLabel || dt('common.document'),
            number:
              doc?.meta?.documentId || doc?.meta?.number
                ? ` #${doc.meta.documentId || doc.meta.number}`
                : '',
            amount: formatMoneyWithCurrency(doc?.amount || 0),
            date: moment(doc?.documentDate).format('DD/MM/YYYY'),
          })}
          <Icon name="x" onClick={() => closeModal()} className="tw-cursor-pointer tw-float-right !tw-size-1" />
        </Modal.Header>

        <div className="tw-py-4 tw-px-5">
          <div className="tw-w-full">
            <FilterTabs
              tabs={tabs}
              activeTab={selectedTab}
              onTabChange={setSelectedTab}
              className="tw-pb-2"
            />
          </div>
        </div>

        <Modal.Content className="tw-h-[calc(82vh-110px)] tw-overflow-auto !tw-p-0">
          {isLoading ? (
            <div className="tw-flex tw-justify-center tw-items-center tw-h-full tw-gap-6">
              <LoadingSpinner
                height="25px"
                afterHeight="25px"
                afterWidth="25px"
              />
            </div>
          ) : result.findDocumentsById.length <= 0 ?
            (
              <div className="tw-flex tw-justify-center tw-items-center tw-h-full">
                <span className="loadingTextSpinner">{dt('detail.noDetails')}</span>
              </div>
            )
            : (
              <BodyDocumentDetail
                data={result.findDocumentsById[0]}
                documentCostCenters={documentCostCenters}
                reexecuteCostCentersByDocument={reexecuteCostCentersByDocument}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                processedData={processedData}
              />
            )}
        </Modal.Content>

        <Modal.Actions className="tw-bg-gray-50 tw-flex tw-justify-end tw-py-[12px]">
          <button
            className="tw-w-[63px] tw-h-[30px] tw-text-white tw-bg-[#0099FF] tw-border-solid tw-border-[1px] tw-border-[#0099FF] tw-rounded-[3px]"
            onClick={() => closeModal()}
          >
            Cerrar
          </button>
        </Modal.Actions>
      </Modal>
    </>
  );
};